import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import type { breadcrumbTrail } from './LocationProfileSEO';

interface LocationProfileBreadcrumbsProps {
  trail: ReturnType<typeof breadcrumbTrail>;
}

/**
 * The yard page's visible breadcrumb, from the same trail as its BreadcrumbList
 * JSON-LD (securspace-ui#3055): Google follows these <a href> links, not the JSON-LD.
 * One line on phones; a long yard name is cut with an ellipsis.
 */
const LocationProfileBreadcrumbs = ({ trail }: LocationProfileBreadcrumbsProps) => {
  const links = trail.slice(0, -1);
  const current = trail[trail.length - 1];
  return (
    <Breadcrumbs aria-label="Breadcrumb" separator="›" sx={{
      fontSize: '0.86rem', mb: 1,
      // The page's wrapping column container sizes children to their content;
      // without a cap, a long name would widen the whole page on phones.
      maxWidth: '100%',
      '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' },
      '& .MuiBreadcrumbs-li:last-of-type': { minWidth: 0 },
    }}>
      {links.map((crumb) => (
        <Link key={crumb.path} component={RouterLink} to={crumb.path} underline="hover" color="inherit" sx={{ whiteSpace: 'nowrap' }}>
          {crumb.name}
        </Link>
      ))}
      <Typography aria-current="page" color="textPrimary" noWrap sx={{ fontSize: 'inherit' }}>
        {current.name}
      </Typography>
    </Breadcrumbs>
  );
};

export default LocationProfileBreadcrumbs;
